import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { EnvironmentService } from '../environment/environment.service'

const defaultTenant = 'mistergreen_nl'

const tenantsWithCheckout = ['mistergreen_nl', 'mistergreen_be', 'mistergreen_dk', 'mistergreen_de']
const tenantsWithReferalProgram = ['mistergreen_nl', 'mistergreen_de']
const tenantsWithInvestmentProgram = ['mistergreen_nl']
const tenantsWithBijtelling = ['mistergreen_nl']
const tenantsWithVAA_ATN = ['mistergreen_be']
const tenantsWithChamberOfCommerceService = ['mistergreen_nl', 'mistergreen_be']
const tenantsWithoutChamberOfCommerceNumber = ['mistergreen_de']

@Injectable({
    providedIn: 'root',
})
export class TenantService {
    tenant$: BehaviorSubject<string>
    hasCheckout$: BehaviorSubject<boolean>
    hasReferalProgram$: BehaviorSubject<boolean>
    hasInvestmentProgram$: BehaviorSubject<boolean>
    hasBijtelling$: BehaviorSubject<boolean>
    hasVAA_ATN$: BehaviorSubject<boolean>
    hasChamberOfCommerceService$: BehaviorSubject<boolean>
    needsChamberOfCommerceNumber$: BehaviorSubject<boolean>

    constructor(environmentService: EnvironmentService) {
        this.tenant$ = new BehaviorSubject<string>(environmentService.environment['tenant'] || defaultTenant)

        const hasCheckout = tenantsWithCheckout.includes(this.tenant$.getValue())
        this.hasCheckout$ = new BehaviorSubject<boolean>(hasCheckout)

        const hasReferalProgram = tenantsWithReferalProgram.includes(this.tenant$.getValue())
        this.hasReferalProgram$ = new BehaviorSubject<boolean>(hasReferalProgram)

        const hasVAA_ATN = tenantsWithVAA_ATN.includes(this.tenant$.getValue())
        this.hasVAA_ATN$ = new BehaviorSubject<boolean>(hasVAA_ATN)

        const hasBijtelling = tenantsWithBijtelling.includes(this.tenant$.getValue())
        this.hasBijtelling$ = new BehaviorSubject<boolean>(hasBijtelling)

        const hasInvestmentProgram = tenantsWithInvestmentProgram.includes(this.tenant$.getValue())
        this.hasInvestmentProgram$ = new BehaviorSubject<boolean>(hasInvestmentProgram)

        const hasChamberOfCommerceService = tenantsWithChamberOfCommerceService.includes(this.tenant$.getValue())
        this.hasChamberOfCommerceService$ = new BehaviorSubject<boolean>(hasChamberOfCommerceService)

        const needsChamberOfCommerceNumber = !tenantsWithoutChamberOfCommerceNumber.includes(this.tenant$.getValue())
        this.needsChamberOfCommerceNumber$ = new BehaviorSubject<boolean>(needsChamberOfCommerceNumber)
    }
}
